var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

// テスト
var _isTest = false;

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

const __layer = $('.st-Container').attr('data-layer');

//preload
import {preload} from "../include/module";
preload();

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//showMovie
import {showMovie} from "../include/module";
showMovie();


$(window).on('resize load' , function() {
  if(windowW <= 1024){
    _isSP = true;
  } else {
    _isSP = false;
  };

  //リサイズ処理 ブレイクポイントを跨いだらリロード
  var nowWidth = window.innerWidth;
  if(prewidth !== nowWidth){
    if(prewidth < 1025) {
      if(nowWidth >= 1025){
        location.reload();
      }
    }else {
      if(nowWidth < 1025){
        location.reload();
      }
    }
  };
});

$(window).on('load' , function() {

  scrollCommonAnime();

  if( __layer == 'first') {
    discographyCategory();
  }else{
    jacketSlide();
    playSond();
  }

});

// ------------------------------------------------------------------------
// discographyCategory
// ----- BOTH
// ------------------------------------------------------------------------
const discographyCategory = () => {

  $(".series_List_All").on("click", function() {
    $(this).next().slideToggle(300);
    $(this).toggleClass("open");
  });

  $(".unit_Btn").on("click", function() {
    $(this).prev().slideToggle(300);
    $(this).toggleClass("open");
  });

// /* ===== Logic for creating fake Select Boxes ===== */
// $('.sel').each(function() {
//   $(this).children('select').css('display', 'none');

//   var $current = $(this);

//   $(this).find('option').each(function(i) {
//     if (i == 0) {
//       $current.prepend($('<div>', {
//         class: $current.attr('class').replace(/sel/g, 'sel__box')
//       }));

//       var placeholder = $(this).text();
//       $current.prepend($('<span>', {
//         class: $current.attr('class').replace(/sel/g, 'sel__placeholder'),
//         text: placeholder,
//         'data-placeholder': placeholder
//       }));

//       return;
//     }

//     $current.children('div').append($('<span>', {
//       class: $current.attr('class').replace(/sel/g, 'sel__box__options'),
//       text: $(this).text()
//     }));
//   });
// });

//   // Toggling the `.active` state on the `.sel`.
//   $('.sel').click(function() {
//     $(this).toggleClass('active');
//   });

//   // Toggling the `.selected` state on the options.
//   $('.sel__box__options').click(function() {
//     var txt = $(this).text();
//     var index = $(this).index();

//     $(this).siblings('.sel__box__options').removeClass('selected');
//     $(this).addClass('selected');

//     var $currentSel = $(this).closest('.sel');
//     $currentSel.children('.sel__placeholder').text(txt);
//     $currentSel.children('select').prop('selectedIndex', index + 1);
//   });

}


// ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  const targets = document.querySelectorAll(".sw-Ttl");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
  const scene = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: 1
    })
    .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
      // console.log("Scene entered.");
      $(target).addClass("is-animated");
      setTimeout(function(){
        $(target).children(".en").textyle(
          {
            duration : 500, //エフェクト時間(ミリ秒)
            delay : 40, //文字間のエフェクト間隔(ミリ秒)
            // easing : 'swing', //エフェクトのイージングパターン
            callback : function(){
              $(target).addClass("is-completed");
            }
          }
        );
      },300);
    })
    // .setClassToggle(target, "is-animated")
    .addTo(controller);
  });

};


// ------------------------------------------------------------------------
// jacketSlide
// ----- BOTH
// ------------------------------------------------------------------------
const jacketSlide = () => {

  var jacketThumb = new Swiper('.discography_Jacket_Thumb_Container', {
    slidesPerView: 3,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: true,//スワイプを可能にするかどうか。デフォルトではtrue。
    speed: 800,
  });

  var jacketImg = new Swiper('.discography_Jacket_Container', {
    loop: true,
    // allowTouchMove: false,//スワイプを可能にするかどうか。デフォルトではtrue。
    speed: 800,
    loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
    // autoplay: {
    //   delay: 3000,
    // },
    thumbs: {
      swiper: jacketThumb
    },
    breakpoints: {
      1024: {
        centeredSlides: false,
        spaceBetween: 0,
      }
    },
  });

};


// ------------------------------------------------------------------------
// playSond
// ----- BOTH
// ------------------------------------------------------------------------
const playSond = () => {
  let _isSound = false;

  $('.play').on('click', function(){

    var parentDOM = event.target;

    const sound = parentDOM.getElementsByClassName('play-data')[0]
    // console.log(sound);

    if(!_isSound) {
      $(this).addClass('is-play');
      sound.currentTime = 0;
      sound.play();
      _isSound = true;

      sound.addEventListener("ended", ()=>{
        $(this).removeClass('is-play');
        _isSound = false;
      });

    }else {
      sound.pause();
      $(this).removeClass('is-play');
      _isSound = false;
    }

    return false ;

  });

};


// WEBPACK FOOTER //
// ./src/marginal4_v0/assets/js/discography/script.js